import { Button, EmptyState } from '@bonanza-social/moonlight';
import animations from '../../assets/animations';
import { useNavigation } from '@bonanza-social/navigation';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { fetchQuests } from '../../state';

export function QuestListEmpty({ state }: { state: 'rejected' | 'empty' }) {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const handlePress = () => {
    if (state === 'rejected') {
      dispatch(fetchQuests());
      navigation.replace('Quests');
    } else {
      navigation.navigate('MainTabNavigator', { screen: 'Games' });
    }
  };

  return (
    <EmptyState
      titleNS="quests"
      descriptionNS="quests"
      {...(state === 'rejected'
        ? {
            titleKey: 'rejectedListTitle',
            descriptionKey: 'rejectedListDescription',
          }
        : {
            titleKey: 'emptyListTitle',
            descriptionKey: 'emptyListDescription',
          })}
      animationSource={animations.promo}
      animationProps={{ sizeX: 150, sizeY: 150 }}
      justifyContent="center"
    >
      <Button
        variant="primary"
        onPress={handlePress}
        {...(state === 'rejected'
          ? { locNS: 'common', locKey: 'reload' }
          : { locNS: 'quests', locKey: 'backToGames' })}
        size="large"
      />
    </EmptyState>
  );
}
